import styled from 'styled-components';
import { COLORS, device, FONTS } from '../../../../constants';

export const PrivacyPolicyAndTermsLinks = () => {
  const text =
    'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.';

  const privacyPolicyIndex = text.indexOf('Privacy Policy');
  const termsOfServiceIndex = text.indexOf('Terms of Service');

  const part1 = text.slice(0, privacyPolicyIndex);
  const part2 = 'Privacy Policy';
  const part3 = text.slice(
    privacyPolicyIndex + part2.length,
    termsOfServiceIndex
  );
  const part4 = 'Terms of Service';
  const part5 = text.slice(termsOfServiceIndex + part4.length);

  return (
    <Container>
      <Text>{part1}</Text>
      <a
        href={process.env.REACT_APP_LINK_GOOGLE_PRIVACY}
        target="_blank"
        rel="noopener noreferrer"
      >
        <LinkText>{part2}</LinkText>
      </a>
      <Text>{part3}</Text>
      <a
        href={process.env.REACT_APP_LINK_GOOGLE_TERMS}
        target="_blank"
        rel="noopener noreferrer"
      >
        <LinkText>{part4}</LinkText>
      </a>
      <Text>{part5}</Text>
    </Container>
  );
};

const Container = styled.div`
  text-align: left;
  max-width: 210px;
  @media screen and ${device.sm} {
    max-width: 100%;
  }
`;

const Text = styled.span`
  color: ${COLORS.FOOTER_TEXT_COLOR};
  font-size: 12px;
  line-height: 14px;
  font-family: ${FONTS.SUBTITLE};
  font-weight: 400;
`;

const LinkText = styled.span`
  color: ${COLORS.WHITE};
  font-size: 12px;
  line-height: 14px;
  font-family: ${FONTS.SUBTITLE};
  font-weight: 400;
  text-decoration: none;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${COLORS.MAIN_RED};
  }
`;
